import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Transition, animated, config } from 'react-spring';

class Accordion extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onTransitionStart: PropTypes.func,
    onTransitionEnd: PropTypes.func,
    id: PropTypes.string,
  };

  static defaultProps = {
    isOpen: false,
    children: null,
    onTransitionStart: () => {},
    onTransitionEnd: () => {},
    id: null,
  };

  constructor(props) {
    super(props);

    this.state = { isOpen: props.isOpen, isTransitioning: false };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen !== state.isOpen) {
      const newState = {
        isOpen: props.isOpen,
        isTransitioning: true,
      };

      props.onTransitionStart({ ...newState });

      return newState;
    }

    return null;
  }

  endTransition() {
    this.setState({ isTransitioning: false }, () => this.props.onTransitionEnd({ ...this.state }));
  }

  render() {
    const { isOpen, isTransitioning } = this.state;
    const { children, id } = this.props;
    const classes = classNames('Accordion', {
      'Accordion--isOpen': isOpen,
    });

    return (
      <div className={classes} id={id}>
        <Transition
          native
          config={{
            ...config.stiff,
            restSpeedThreshold: 0.2,
            restDisplacementThreshold: 0.2,
            overshootClamping: true,
          }}
          from={{ height: 0, opacity: 0 }}
          enter={{
            opacity: 1,
            height: 'auto',
          }}
          leave={{ height: 0, opacity: 0 }}
          onDestroyed={() => {
            if (isTransitioning) {
              this.endTransition();
            }
          }}
        >
          {isOpen &&
            (styles => (
              <animated.div
                style={{
                  ...styles,
                  overflow: 'hidden',
                  width: '100%',
                }}
                className="Accordion__drawer"
              >
                {children}
              </animated.div>
            ))}
        </Transition>
        {!isOpen && <div className="hiddenChildren">{children}</div>}

        <style jsx>
          {`
            .Accordion {
              position: relative;
              overflow: hidden;
            }
            .hiddenChildren {
              display: none;
            }
          `}
        </style>
      </div>
    );
  }
}

export default Accordion;
